import React from 'react';
import { PERF_STATS, PERFORMANCE_HEADER } from '../constants';
import { useLanguage } from '../LanguageContext';

export default function Performance() {
  const { lang }  = useLanguage();
  const stats     = PERF_STATS[lang];
  const header    = PERFORMANCE_HEADER[lang];

  return (
    <section className="pb-section pb-section-pad-sm" id="performances" data-testid="pb-performance">
      <div className="pb-container">
        <div style={{ textAlign: 'center', maxWidth: 520, margin: '0 auto 0' }}>
          <div className="pb-label" style={{ justifyContent: 'center' }}>{header.label}</div>
          <h2 className="pb-section-title">{header.title}</h2>
          <p className="pb-section-sub" style={{ margin: '16px auto 0', textAlign: 'center' }}>{header.sub}</p>
        </div>

        <div className="pb-perf-grid">
          {stats.map(stat => (
            <div key={stat.value} className="pb-perf-item" data-testid={`pb-perf-${stat.value.toLowerCase()}`}>
              <div className="pb-perf-value">{stat.value}</div>
              <div className="pb-perf-label">{stat.label}</div>
              <div className="pb-perf-sub">{stat.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
